"use client";

import { TestModeStrip } from "@perksmith/design-kit";

import { counterTestModeOn } from "@/lib/counter/test-mode";
import { usePosSession } from "@/lib/hooks/usePosSession";

/**
 * The strip across the top of the Counter and the Reward Desk while the business has Test mode on for its counters,
 * so a cashier cannot ring a real sale on test data without knowing. It follows `/pos/context`, which is read again
 * on the next sign-in or reload.
 */
export function CounterTestModeStrip() {
  const { settings } = usePosSession();
  return counterTestModeOn(settings) ? <TestModeStrip /> : null;
}
